export default function mobileMenu() {
    const burger = document.querySelector('.mobile-menu-icon');
    const menu = document.querySelector('#mobile-menu');
    const nav = menu?.querySelector('.mobile-menu');
    const header = document.querySelector('.main-header');

    if (!burger || !menu || !nav || !header) return;

    const setMenuTopFromHeader = () => {
        const notice = document.querySelector('.notice-wrapper:not([hidden])');
        const noticeHeight = notice ? notice.offsetHeight : 0;
        const height = header.offsetHeight + noticeHeight;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
        menu.style.height = '';
    };

    const open = () => {
        setMenuTopFromHeader();
        burger.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
        document.documentElement.classList.add('is-mobile-menu-open');
        resetToRootPanel();
    };

    const close = () => {
        burger.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        document.documentElement.classList.remove('is-mobile-menu-open');
        resetToRootPanel();
    };

    const toggle = () => {
        const isOpen = burger.getAttribute('aria-expanded') === 'true';
        isOpen ? close() : open();
    };

    burger.addEventListener('click', (e) => {
        e.preventDefault();
        toggle();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
            close();
        }
    });

    window.addEventListener('resize', () => {
        if (burger.getAttribute('aria-expanded') === 'true') {
            setMenuTopFromHeader();
        }
    });

    window.addEventListener('scroll', () => {
        if (burger.getAttribute('aria-expanded') === 'true') {
            setMenuTopFromHeader();
        }
    }, { passive: true });

    const rootUl = nav.querySelector(':scope > ul');
    if (!rootUl) return;

    const panels = document.createElement('div');
    panels.className = 'mobile-menu-panels';

    nav.innerHTML = '';
    nav.appendChild(panels);

    const stack = [];
    let activeIndex = 0;

    const setActivePanel = (newIndex) => {
        activeIndex = newIndex;

        stack.forEach((item, i) => {
            item.panelEl.classList.remove('is-active', 'is-prev');

            if (i === activeIndex) item.panelEl.classList.add('is-active');
            else if (i < activeIndex) item.panelEl.classList.add('is-prev');
        });
    };

    const goBack = () => {
        if (activeIndex === 0) return;

        setActivePanel(activeIndex - 1);

        const last = stack.pop();
        if (last) {
            window.setTimeout(() => last.panelEl.remove(), 320);
        }
    };

    const makePanel = ({ level, title, parentTitle, ulEl }) => {
        const panel = document.createElement('div');
        panel.className = 'mobile-menu-panel';
        panel.dataset.level = String(level);

        if (level > 1) {
            const backWrapper = document.createElement('div');
            backWrapper.className = 'mobile-menu-back-wrapper';

            const back = document.createElement('button');
            back.type = 'button';
            back.className = 'mobile-menu-back';
            back.innerHTML = `<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M5.46655 0.800003L0.799886 5.46667L5.46655 10.1333" stroke="#953192" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span>Back to ${escapeHtml(parentTitle || 'main menu')}</span>`;
            back.addEventListener('click', goBack);

            backWrapper.appendChild(back);
            panel.appendChild(backWrapper);
        }

        const inner = document.createElement('div');
        inner.className = 'mobile-menu-panel-inner';

        inner.appendChild(ulEl);
        panel.appendChild(inner);

        return panel;
    };

    const prependParentLinkItem = (ulEl, sourceLink) => {
        if (!ulEl || !sourceLink) return;

        const href = sourceLink.getAttribute('href');
        const label = sourceLink.textContent?.trim() || '';
        if (!href || !label) return;

        const li = document.createElement('li');
        li.className = 'submenu-parent-link';

        const a = document.createElement('a');
        a.href = href;
        a.textContent = label;

        const target = sourceLink.getAttribute('target');
        if (target) a.setAttribute('target', target);

        const rel = sourceLink.getAttribute('rel');
        if (rel) a.setAttribute('rel', rel);

        li.appendChild(a);
        ulEl.insertBefore(li, ulEl.firstChild);
    };

    const pushPanelFromSubmenu = (li) => {
        const link = li.querySelector(':scope > a');
        const submenu = li.querySelector(':scope > .sub-menu');
        if (!link || !submenu) return;

        const title = link.textContent?.trim() || '';
        const parentTitle = stack[activeIndex]?.title || 'main menu';

        const clonedUl = submenu.cloneNode(true);
        clonedUl.classList.remove('sub-menu');
        prependParentLinkItem(clonedUl, link);

        const newPanel = makePanel({
            level: activeIndex + 2,
            title,
            parentTitle,
            ulEl: clonedUl,
        });

        panels.appendChild(newPanel);

        while (stack.length - 1 > activeIndex) {
            const removed = stack.pop();
            removed.panelEl.remove();
        }

        stack.push({ panelEl: newPanel, title });
        setActivePanel(stack.length - 1);
    };

    const resetToRootPanel = () => {
        while (stack.length > 1) {
            const last = stack.pop();
            last.panelEl.remove();
        }
        setActivePanel(0);
    };

    const level1Panel = makePanel({
        level: 1,
        title: null,
        parentTitle: null,
        ulEl: rootUl,
    });

    panels.appendChild(level1Panel);
    stack.push({ panelEl: level1Panel, title: 'main menu' });

    panels.addEventListener('click', (e) => {
        const a = e.target.closest('a');
        if (!a) return;

        const li = a.closest('li');
        if (!li) return;

        if (li.classList.contains('menu-item-has-children')) {
            const submenu = li.querySelector(':scope > .sub-menu');
            if (submenu) {
                e.preventDefault();
                pushPanelFromSubmenu(li);
            }
        }
    });

    setActivePanel(0);

    function escapeHtml(str) {
        return String(str)
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;');
    }
}
